import { useGetDetailPropertyQuery } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";
import PropertyDetailAdapter from "@rf/property/module/adapters/PropertyDetailAdapter";

import { useMemo } from "react";

import { useParams } from "react-router-dom";

export const useLoaderPropertyDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const { data: GET_DETAIL_PROPERTY_DATA, status: GET_DETAIL_PROPERTY_STATUS } =
    useGetDetailPropertyQuery(
      {
        params: {
          id: id ?? ""
        }
      },
      {
        skip: !id
      }
    );

  const data = useMemo(() => {
    if (GET_DETAIL_PROPERTY_DATA && GET_DETAIL_PROPERTY_STATUS === "fulfilled") {
      return PropertyDetailAdapter(GET_DETAIL_PROPERTY_DATA);
    } else {
      return null;
    }
  }, [GET_DETAIL_PROPERTY_DATA, GET_DETAIL_PROPERTY_STATUS]);

  return {
    data: data,
    status: GET_DETAIL_PROPERTY_STATUS
  };
};
